<template>
    <div>
      <h2>{{ formTitle | upper }}</h2>
      <el-form ref="form" :model="form" label-width="120px" :label-position="'top'" >

        <el-row :gutter="20">
          <el-col :lg="12" :xl="12">
            <el-form-item :label="$t('name')">
              <el-input placeholder="Nom du produit" v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xl="12">
            <el-form-item :label="$t('type')">
              <el-input placeholder="Type du produit" v-model="form.type"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :lg="12" :xl="12">
            <el-form-item :label="$t('associated_beacon_id')">
              <el-input :placeholder="$t('associated_beacon_id')" v-model="form.beaconId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :xl="12">
            <el-form-item label="Description">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="description"
                v-model="form.description">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="form-row-margin">
          <el-col :lg="12">
            <el-tag
              :key="tag"
              v-for="tag in form.tags"
              closable
              :disable-transitions="false"
              @close="handleCloseTag(tag)">
              {{tag}}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="tagInputVisible"
              v-model="tagInputValue"
              ref="saveTagInput"
              size="mini"
              @keyup.enter.native="handleInputConfirmTag"
              @blur="handleInputConfirmTag"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInputTag">+ {{ $t('add_tag') }}</el-button>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item>
            <el-button type="success" @click="createProduct">{{ $t(formState) | upper }}</el-button>
            <el-button @click="initFormAndClose">ANNULER</el-button>
          </el-form-item>
        </el-row>

      </el-form>
    </div>
</template>

<script>
//-- WIP (no axios or store)

import { productTable } from '../../data/dynamoDBSimulation.js'; //-- Simulate Data from DynamoDB
import CleanObject from '../../mixins/CleanObject';
import DateTimeManipulation from '../../mixins/DateTimeManipulation';

export default {
  props: {
    formStateModal: {
      type: String,
    },
    productSelected: {
      type: Object
    },
    formTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formState: 'create',
      tagInputVisible: false,
      tagInputValue: '',
      form: {
        id: '',
        name: '',
        type: '',
        description: '',
        beaconId: '',
        tags: []
      }
    }
  },
  created () {
    if(this.formStateModal !== undefined) {
      this.formState = this.formStateModal;
    } else {
      this.setFormState(this.$route.name);
    }
    if(this.productSelected !== undefined) {
      this.setForm(this.productSelected);
    } else if(this.formState === 'edit' || this.formState === 'duplicate') {
      //-- Fetch Product with his id
      let selectedProduct = productTable.find( elmt => elmt.id === this.form.id );
      this.setForm(selectedProduct);
    }
  },
  methods: {
    setFormState: function(routeName) {
      if(routeName.includes('create')) {
        this.formState = 'create';
      } else if(routeName.includes('duplicate')) {
        this.formState = 'duplicate';
        this.form.id = this.$route.params.id;
      } else if(routeName.includes('edit')) {
        this.formState = 'edit';
        this.form.id = this.$route.params.id;
      }
    },
    handleCloseTag(tag) {
      this.form.tags.splice(this.form.tags.indexOf(tag), 1);
    },
    showInputTag() {
      this.tagInputVisible = true;
      this.$nextTick( () => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirmTag() {
      let inputValue = this.tagInputValue;
      if (inputValue) {
        this.form.tags.push(inputValue);
      }
      this.tagInputVisible = false;
      this.tagInputValue = '';
    },
    setForm: function(data) {
      this.form.name = data.name;
      this.form.type = data.type;
      this.form.description = data.description;
      this.form.beaconId = data.beaconId;
      this.form.tags = data.tags !== undefined ?  data.tags : [];
    },
    initForm: function() {
      this.form = {
        id: '',
        name: '',
        type: '',
        description: '',
        beaconId: '',
        tags: []
      },
      this.checkboxMachines = [];
    },
    initFormAndClose: function() {
      this.$emit('closeForm', false);
    },
    createProduct: function() {
      let cleanedForm = this.cleanObject(this.form);
      if(this.formState === 'create' || this.formState === 'duplicate') {
        this.$store.dispatch('postProduct', cleanedForm)
        .then( res => {
          this.$message({
            message: res.message,
            type: res.type
          });
          [200, 201].include(res.status) ? this.initForm() : '';
        })
      }
      if(this.formState === 'edit') {
        cleanedForm.id = this.ofSelected.id
        this.$store.dispatch('editOperator', cleanedForm)
        .then( res => {
          this.$message({
            message: res.message,
            type: res.type
          });
          [200, 201].include(res.status) ? this.initForm() : '';
        })
      }
    }
  },
  mixins: [CleanObject, DateTimeManipulation]
}
</script>

<style scoped>
  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .form-row-margin {
    margin-bottom: 24px;
  }
</style>